// -----------Input parameter of FIRST GRAPH (getBillerTransactionGraph) fetch biller Biller Transaction.............
export class ViewBillerTransactionGraphs {
    billerid: string;
    datafor: string;
    startdate: string;
    enddate: string;
    mode: string;
}
// -----------Output parameter of FIRST GRAPH (getBillerTransactionGraph) fetch biller Biller Transaction.............
export class BillerTransactions {
    timeperiod: string[];
    txns: number[];
    amount: number[];
}

// -----------Input parameter of (getBillerTxnsReportDataView) and (getBillerKeyPerformanceIndicator)
// (getBillerRecentTransaction) fetch biller txns dashboard report-----------
//-------------(getBillerTxnsAmountView)
export class InputBillerTxsnReport {
    id: string;
    datafor: string;
    startdate: string;
    enddate: string;
    mode: string;
}
// -----------output parameter of  (getBillerTxnsReportDataView)  fetch biller txns dashboard report.............
export class BillerTransactionReport {
    response: string;
    reason: string;
    var_total_amount: number;
    var_total_txns: number;
    var_success_rate: number;
    var_success_txns: number;
    data_for: string;
    var_fail_txns: number;
}
// ------------------output parameter for (getBillerKeyPerformanceIndicator) fetch biller key performance indicator----------------
export class KeyPerformanceOutput {
    response: string;
    reason: string;
    total_amount: number;
    success_rate: number;
    txns_count: number;
}

// -----------Output parameter of (getBillerRecentTransaction) fetch biller recent transactions.............
export class RecentTransaction {
    tnx_date: string;
    ref_id: string;
    bill_amount_total: number;
    tnx_time: string;
    bill_revenue_stamp_amount: number;
    bill_vat: number;
   biller: string;
   pi: string;
}
export class RecentTxsnMain {
    data_for: string;
    reason: string;
    response: string;
    recent_transactions: RecentTransaction[];
}

// and FOR recent transactionsss------------
//and FOR fetch biller key performance indicator.............
export class ViewBillerDashboard{
    datafor: string;
    startdate: string;
    enddate: string;
    mode: string;
}

//------------------output parameter transaction Amount ----

export class TransactionAmountOutput {
    date_hour: string[];
    total_amount: number[];
}



// WEBPACK FOOTER //
// ./src/app/dashboards/biller-dashboard/view-biller-Graphs.ts